import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { translations } from "../../i18n/translations";
import { fetchReferences } from "../../lib/api";
import SectionHeading from "../SectionHeading";
import Reveal from "../Reveal";
import ReferenceCard from "../ReferenceCard";
import RefLogo from "../RefLogo";

const References = () => {
  const { lang } = useLanguage();
  const t = translations[lang].references;
  const [refs, setRefs] = useState([]);

  useEffect(() => {
    fetchReferences().then(setRefs).catch(console.error);
  }, []);

  if (refs.length === 0) return null;
  const featured = refs.filter((r) => r.featured).slice(0, 3);

  return (
    <section className="relative bg-navy-950 py-20 lg:py-28 overflow-hidden" data-testid="home-references">
      <div className="absolute inset-0 grid-pattern opacity-40" />
      <div className="absolute -bottom-40 -left-20 w-[28rem] h-[28rem] rounded-full bg-amber-500/10 blur-[120px]" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
          <SectionHeading tag={t.tag} title={t.title} desc={t.desc} light />
          <Link
            to="/referanslar"
            className="inline-flex items-center gap-2 text-amber-400 hover:text-amber-300 font-semibold shrink-0 group"
            data-testid="home-references-all-link"
          >
            {t.viewAll}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        <div className="mt-12 flex flex-wrap items-center gap-3 lg:gap-4">
          {refs.map((r, i) => (
            <Reveal key={r.id} delay={i * 50}>
              <Link
                to="/referanslar"
                className="flex items-center gap-2.5 rounded-full bg-white/[0.04] border border-white/10 pl-1.5 pr-4 py-1.5 hover:border-amber-500/40 hover:bg-white/[0.07] transition-colors"
                title={r.name}
              >
                <RefLogo name={r.name} logo={r.logo} size="sm" dark />
                <span className="text-sm font-medium text-slate-200 whitespace-nowrap">{r.name}</span>
              </Link>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((r, i) => (
            <Reveal key={r.id} delay={i * 100}>
              <ReferenceCard r={r} dark />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default References;
